var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0291 30.3087L10.337 32.5502L12.206 31.1323L18.999 25.979L25.7615 31.1314L27.6342 32.5582L26.9396 30.3087L24.3419 21.8955L31.1876 16.4661L32.8842 15.1205H30.7187H22.3925L19.7178 6.8613L19 4.64488L18.2822 6.8613L15.6075 15.1205H7.28125H5.1231L6.81118 16.4651L13.6272 21.8944L11.0291 30.3087ZM19 1.00447C28.9271 1.00447 36.9955 9.07293 36.9955 19C36.9955 28.9271 28.9271 36.9955 19 36.9955C9.07293 36.9955 1.00447 28.9271 1.00447 19C1.00447 9.07293 9.07293 1.00447 19 1.00447Z",
    fill: "#F7F2EC",
    stroke: "#F7F2EC",
    strokeWidth: 1.50895
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalidad);
export default __webpack_public_path__ + "static/media/ic_calidad.7db14317754045a988846d943a78c6d0.svg";
export { ForwardRef as ReactComponent };